(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coa037-trustpilot-reviews"]) return;
  try {
    
  (() => {
    const INITIAL_REVIEW_COUNT = 6;
    const REVIEW_BATCH_SIZE = 6;
    const HEIGHT_TRANSITION_MS = 360;
    const HEIGHT_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

    const initialiseWidget = (widget) => {
      if (!widget || widget.dataset.coa037ReviewsToggleReady === 'true') return;

      const button = widget.querySelector('[data-coa037-reviews-toggle]');
      const desktopInitialReviews = widget.querySelector('[data-coa037-desktop-initial-reviews]');
      const additionalReviews = widget.querySelector('[data-coa037-more-reviews]');
      const label = widget.querySelector('[data-coa037-reviews-toggle-label]');
      const reviewCards = Array.from(widget.querySelectorAll('.coa037-review-card'));

      if (!button || !desktopInitialReviews || !additionalReviews || !label) return;

      widget.dataset.coa037ReviewsToggleReady = 'true';
      let isAnimating = false;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const normaliseVisibleReviewCount = (requestedCount) => {
        return Math.min(
          Math.max(requestedCount, INITIAL_REVIEW_COUNT),
          reviewCards.length
        );
      };

      const updateButtonState = (visibleReviewCount) => {
        const reachedEnd = visibleReviewCount >= reviewCards.length;

        widget.dataset.coa037VisibleReviews = String(visibleReviewCount);
        button.dataset.coa037AtEnd = String(reachedEnd);
        button.setAttribute('aria-expanded', String(visibleReviewCount > INITIAL_REVIEW_COUNT));
        label.textContent = reachedEnd
          ? widget.dataset.labelLessReviews
          : widget.dataset.labelMoreReviews;
      };

      const setVisibleReviewCount = (requestedCount) => {
        const visibleReviewCount = Math.min(
          Math.max(requestedCount, INITIAL_REVIEW_COUNT),
          reviewCards.length
        );

        reviewCards.forEach((card, index) => {
          card.hidden = index >= visibleReviewCount;
        });

        additionalReviews.hidden = visibleReviewCount <= INITIAL_REVIEW_COUNT;
        updateButtonState(visibleReviewCount);
      };

      const clearHeightAnimationStyles = () => {
        additionalReviews.style.height = '';
        additionalReviews.style.overflow = '';
        additionalReviews.style.transition = '';
        additionalReviews.style.willChange = '';
        widget.removeAttribute('aria-busy');
        isAnimating = false;
      };

      const animateAdditionalReviewsHeight = (startHeight, endHeight, keepButtonAnchored, onComplete) => {
        let anchorFrame = null;
        let completed = false;
        const anchorTop = button.getBoundingClientRect().top;
        const previousOverflowAnchor = {
          widget: widget.style.overflowAnchor,
          root: document.documentElement.style.overflowAnchor,
          body: document.body.style.overflowAnchor,
        };

        isAnimating = true;
        widget.setAttribute('aria-busy', 'true');
        widget.style.overflowAnchor = 'none';
        document.documentElement.style.overflowAnchor = 'none';
        document.body.style.overflowAnchor = 'none';
        additionalReviews.style.height = `${startHeight}px`;
        additionalReviews.style.overflow = 'hidden';
        additionalReviews.style.transition = 'none';
        additionalReviews.style.willChange = 'height';
        void additionalReviews.offsetHeight;

        const correctButtonPosition = () => {
          const offset = button.getBoundingClientRect().top - anchorTop;
          if (Math.abs(offset) > 0.5) window.scrollBy(0, offset);
        };

        const maintainButtonPosition = () => {
          correctButtonPosition();
          anchorFrame = window.requestAnimationFrame(maintainButtonPosition);
        };

        const finish = () => {
          if (completed) return;

          completed = true;
          additionalReviews.removeEventListener('transitionend', handleTransitionEnd);
          if (anchorFrame !== null) window.cancelAnimationFrame(anchorFrame);
          onComplete();
          clearHeightAnimationStyles();
          widget.style.overflowAnchor = previousOverflowAnchor.widget;
          document.documentElement.style.overflowAnchor = previousOverflowAnchor.root;
          document.body.style.overflowAnchor = previousOverflowAnchor.body;
          if (keepButtonAnchored) {
            correctButtonPosition();
            window.requestAnimationFrame(correctButtonPosition);
          }
        };

        const handleTransitionEnd = (event) => {
          if (event.target === additionalReviews && event.propertyName === 'height') finish();
        };

        additionalReviews.addEventListener('transitionend', handleTransitionEnd);
        window.setTimeout(finish, HEIGHT_TRANSITION_MS + 120);

        if (keepButtonAnchored) maintainButtonPosition();

        window.requestAnimationFrame(() => {
          additionalReviews.style.transition = `height ${HEIGHT_TRANSITION_MS}ms ${HEIGHT_EASING}`;
          window.requestAnimationFrame(() => {
            additionalReviews.style.height = `${endHeight}px`;
          });
        });
      };

      const centreButtonBeforeCollapse = (onComplete) => {
        const buttonRect = button.getBoundingClientRect();
        const targetTop = Math.max(24, (window.innerHeight - buttonRect.height) / 2);
        const scrollDistance = buttonRect.top - targetTop;

        if (Math.abs(scrollDistance) <= 24) {
          onComplete();
          return;
        }

        const startScrollY = window.scrollY;
        const maximumScrollY = document.documentElement.scrollHeight - window.innerHeight;
        const targetScrollY = Math.min(
          Math.max(startScrollY + scrollDistance, 0),
          maximumScrollY
        );
        const startTime = performance.now();
        const duration = 180;

        isAnimating = true;

        const animateScroll = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);

          window.scrollTo(0, startScrollY + ((targetScrollY - startScrollY) * easedProgress));

          if (progress < 1) {
            window.requestAnimationFrame(animateScroll);
            return;
          }

          onComplete();
        };

        window.requestAnimationFrame(animateScroll);
      };

      const revealNextBatch = (currentVisibleReviewCount) => {
        const nextVisibleReviewCount = normaliseVisibleReviewCount(
          currentVisibleReviewCount + REVIEW_BATCH_SIZE
        );
        const startHeight = additionalReviews.hidden ? 0 : additionalReviews.offsetHeight;
        const newlyVisibleCards = reviewCards.slice(
          currentVisibleReviewCount,
          nextVisibleReviewCount
        );

        additionalReviews.hidden = false;
        additionalReviews.style.height = 'auto';
        reviewCards.forEach((card, index) => {
          card.hidden = index >= nextVisibleReviewCount;
        });

        const endHeight = additionalReviews.scrollHeight;
        updateButtonState(nextVisibleReviewCount);

        newlyVisibleCards.forEach((card, index) => {
          card.style.setProperty('--coa037-review-reveal-delay', `${index * 18}ms`);
          card.classList.remove('coa037-review-card--revealing');
          void card.offsetWidth;
          card.classList.add('coa037-review-card--revealing');
          window.setTimeout(() => {
            card.classList.remove('coa037-review-card--revealing');
            card.style.removeProperty('--coa037-review-reveal-delay');
          }, 380);
        });

        animateAdditionalReviewsHeight(startHeight, endHeight, false, () => {});
      };

      const collapseReviews = () => {
        const anchorTop = button.getBoundingClientRect().top;

        if (prefersReducedMotion) {
          setVisibleReviewCount(INITIAL_REVIEW_COUNT);
          window.scrollBy(0, button.getBoundingClientRect().top - anchorTop);
          return;
        }

        centreButtonBeforeCollapse(() => {
          const startHeight = additionalReviews.offsetHeight;
          widget.dataset.coa037VisibleReviews = String(INITIAL_REVIEW_COUNT);
          updateButtonState(INITIAL_REVIEW_COUNT);
          additionalReviews.classList.add('coa037-is-collapsing');

          animateAdditionalReviewsHeight(startHeight, 0, true, () => {
            reviewCards.forEach((card, index) => {
              card.hidden = index >= INITIAL_REVIEW_COUNT;
            });
            additionalReviews.hidden = true;
            additionalReviews.classList.remove('coa037-is-collapsing');
          });
        });
      };

      setVisibleReviewCount(INITIAL_REVIEW_COUNT);

      button.addEventListener('click', () => {
        if (isAnimating) return;

        const visibleReviewCount = Number.parseInt(
          widget.dataset.coa037VisibleReviews || String(INITIAL_REVIEW_COUNT),
          10
        );

        if (visibleReviewCount >= reviewCards.length) {
          collapseReviews();
          return;
        }

        if (prefersReducedMotion) {
          setVisibleReviewCount(visibleReviewCount + REVIEW_BATCH_SIZE);
          return;
        }

        revealNextBatch(visibleReviewCount);
      });
    };

    const initialiseAll = (root = document) => {
      root.querySelectorAll('[data-coa037-widget]').forEach(initialiseWidget);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
